<template>
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useEventStreamStore } from './shared/events/stream'

useEventStreamStore()
</script>
